export const useStoreGetTransaction = () => {
  const LOCAL_STORAGE_KEY = 'lastPrintedTicketsTransaction';

  const storeLastTransaction = (transaction) => {
    try {
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(transaction));
    } catch (e) {
      console.error('Failed to store last transaction in localStorage', e);
    }
  };

  const getLastTransaction = () => {
    try {
      const raw = localStorage.getItem(LOCAL_STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      console.error('Failed to read last transaction from localStorage', e);
      return null;
    }
  };

  return {
    storeLastTransaction,
    getLastTransaction,
  };
};
